import GeoActionTypes from './geo.types';

const initialState = {
  currentGeo: null,
  site: 'Comtel Technologies'
};

export default function geoReducer(state = initialState, { type, payload }) {
  switch (type) {
    case GeoActionTypes.SET_GEO_DATA_SUCCESS:
      return {
        ...state,
        currentGeo: payload
      };
    default:
      return state;
  }
}
